import React from "react";
import "./Member_Banner.css";

const Member_Banner = () => {
  return (
    <section className="member_banner">
      <div className="container-fluid">
        <div className="member_info_holder">
          <div className="member_info">
            <p className="numbers">958+</p>
            <p className="names">Members</p>
          </div>

          <div className="member_info">
            <p className="numbers">379+</p>
            <p className="names">Gyms</p>
          </div>

          <div className="member_info">
            <p className="numbers">150+</p>
            <p className="names">Cities</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Member_Banner;
